import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Else, If, Then } from 'react-if';
import { Color } from '../../../common/view/color/color';
import { ServerApiStore } from '../../../external/server/server.api.store';
import { StringFuncs } from '../../../foundation/js/string.funcs';
import { TripleX } from '../../../foundation/layout/triple-x';
import { AuthStateContext } from '../../core/user/auth.context';
import { UserBarStyle } from './user-bar.style';

export function UserBar() {
  const { user, loginWithRedirect, isAuthenticated, getAccessTokenSilently, logout } = useAuth0();
  const authState = AuthStateContext.use();

  useEffect(() => {
    (async () => {
      try {
        if (isAuthenticated && StringFuncs.isEmpty(ServerApiStore.getToken())) {
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: `https://api.usemegaboard.com`,
            },
          });
          ServerApiStore.setToken(accessToken);
          authState.setState({ isAuthenticated: true });
        }
      } catch (e) {
        console.log(e);
      }
    })();
  }, [isAuthenticated]);

  return (
    <UserBarStyle.Container>
      <If condition={authState.state.isAuthenticated}>
        <Then>
          <TripleX.Container $align="center" style={{ gap: '10px' }}>
            <TripleX.Rest>
              <div style={{ fontSize: 14, color: Color.white4 }}>{user?.email}</div>
            </TripleX.Rest>
            <TripleX.Side>
              <div style={{ fontSize: 14, color: Color.white4 }} onClick={() => logout()}>
                logout
              </div>
            </TripleX.Side>
          </TripleX.Container>
        </Then>
        <Else>
          <div style={{ fontSize: 14, color: Color.white4 }} onClick={() => loginWithRedirect()}>
            login
          </div>
        </Else>
      </If>
    </UserBarStyle.Container>
  );
}
